import { useAppStore } from "@hooks/useAppStore";
import Box from "@memorang/ui/components/Box";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { Tabs } from "expo-router";
import { Pressable } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useBottomTabs } from "../hooks/useBottomTabs";

export const AppBottomTabs = () => {
	const theme = useAppTheme();
	const appFont = useAppStore((store) => store.app.font);
	const insets = useSafeAreaInsets();
	const tabs = useBottomTabs();

	return (
		<Tabs
			screenOptions={{
				headerShown: false,
				tabBarActiveTintColor: theme.colors.onSecondaryContainer,
				tabBarButton: ({ ref, ...rest }) => (
					<Pressable {...rest} android_ripple={{ color: "transparent" }} />
				),
				tabBarStyle: {
					height: 80 + insets.bottom,
					borderTopWidth: 0,
					backgroundColor: theme.colors.elevation.level2,
					paddingTop: 16,
				},
				tabBarLabelStyle: {
					fontFamily: `${appFont}-regular`,
					fontSize: 12,
					paddingBottom: 16,
					color: theme.colors.text,
				},
			}}
		>
			{tabs.map(({ name, icon, activeIcon, title, enabled }) => (
				<Tabs.Screen
					key={name}
					name={name}
					options={{
						...(enabled ? {} : { href: null }),
						tabBarIcon: ({ focused, color }) => (
							<Box
								width={64}
								height={34}
								borderRadius={34 / 2}
								backgroundColor={
									focused ? theme.colors.secondaryContainer : "transparent"
								}
								alignItems="center"
								justifyContent="center"
								marginBottom={12}
							>
								{(focused ? activeIcon : icon)({ size: 24, color })}
							</Box>
						),
						tabBarLabel: title,
					}}
				/>
			))}
		</Tabs>
	);
};
